<template>
  <v-select
    :items="callResultOptions"
    item-value="id"
    item-text="name"
    v-model="selectedCallResults"
    hide-details="auto"
    label="Görüşme Sonuç Kodu"
    :multiple="multiple"
    @input="emitSelectedCallResults"
  >
    <template v-slot:selection="{ item, index }">
      <v-chip
        close
        small
        @click:close="selectedCallResults.splice(index, 1)"
        v-if="multiple"
      >
        <span>{{ item.name }}</span>
      </v-chip>
      <span v-else>{{ item.name }}</span>
    </template>
  </v-select>
</template>

<script>
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "SM-Call-Result-Selectbox",
  props: {
    value: {
      type: Number,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedCallResults: this.value,
    };
  },
  methods: {
    emitSelectedCallResults() {
      if (this.multiple) {
        this.$emit(
          "update:value",
          this.callResultOptions.filter((status) =>
            this.selectedCallResults.includes(status.id)
          )
        );
        return;
      }
      this.$emit("update:value", this.selectedCallResults);
    },
  },
  computed: {
    ...mapGetters(["callResultCodes"]),
    callResultOptions() {
      return this.callResultCodes.map((code) => ({
        id: code.id,
        name: code.text,
      }));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.selectedCallResults = value;
      },
    },
  },
});
</script>
